export default __webpack_public_path__ + "static/media/Puzzul.0c86ed54.svg";